import { graphSlice, DEFAULT_GRAPH_STATE, GRAPH_PREFERENCE_BASE, GRAPH_PREFERENCE_FIELDS, selectGraphPanelForSync } from "../store/graph-slice"
import { createSyncPreferencesHook } from "./create-sync-preferences-hook"

const useSyncGraphPreferencesBase = createSyncPreferencesHook({
  selectPanelState: selectGraphPanelForSync,
  defaultState: DEFAULT_GRAPH_STATE,
  preferenceBase: GRAPH_PREFERENCE_BASE,
  preferenceFields: GRAPH_PREFERENCE_FIELDS,
  setPreferences: (dashboardId, panelId, prefs) =>
    graphSlice.actions.setPreferences({ dashboardId, panelId, ...prefs }),
  clearPendingClonePersist: (dashboardId, panelId) =>
    graphSlice.actions.clearPendingClonePersist({ dashboardId, panelId }),
})

/**
 * Per-panel sync. Must be called from within both a DashboardIdContext and a PanelIdContext
 * provider. Returns true once preferences have been loaded for this (dashboardId, panelId) pair.
 *
 * NOT added to useDashboardPreferencesSync — graph prefs are panel-scoped and load when the graph
 * panel mounts, not at dashboard layout level.
 */
export function useSyncGraphPreferences(): boolean {
  return useSyncGraphPreferencesBase()
}
